import { colors as r } from "../../foundations/colors.es.js";
import { $elevation1 as a } from "../../foundations/shadows.es.js";
import { hexToRgbaString as i } from "../../../utils/colors.es.js";
import { transformPxToRem as e } from "../../../utils/units.es.js";
import { createMultiStyleConfigHelpers as l, cssVar as n, defineStyle as o } from "@chakra-ui/react";
import { ToggleAnatomy as s } from "./Toggle.anatomy.es.js";
const { definePartsStyle: c, defineMultiStyleConfig: d } = l(
  s.keys
), t = n("toggle-control-shadow-color"), p = o({
  minHeight: "size-250",
  minWidth: "size-500",
  position: "relative",
  alignItems: "center",
  borderRadius: "full",
  transition: "all 500ms",
  '&[data-state="checked"]': {
    backgroundColor: "secondary.500",
    "&[data-hover]": {
      backgroundColor: "secondary.600"
    },
    "&:has(+ input:focus-visible)": {
      backgroundColor: "secondary.600"
    },
    "&:active": {
      backgroundColor: "secondary.700"
    }
  },
  '&[data-state="unchecked"]': {
    backgroundColor: "primary.100",
    _dark: {
      backgroundColor: "primary.500"
    },
    "&[data-hover]": {
      backgroundColor: "primary.200",
      _dark: {
        backgroundColor: "primary.400"
      }
    },
    "&:has(+ input:focus-visible)": {
      backgroundColor: "primary.200",
      _dark: {
        backgroundColor: "primary.400"
      }
    },
    "&:active": {
      backgroundColor: "primary.300"
    }
  }
}), m = o({
  color: "primary.700",
  lineHeight: e(22),
  svg: {
    color: "primary.300",
    boxSize: 4,
    verticalAlign: "text-top",
    // to center the icon vertically with the label
    display: "flex"
  },
  _dark: {
    color: "white"
  }
}), b = o({
  display: "flex",
  flexDirection: "column"
}), u = o({
  '& > input[type="checkbox"]': {
    opacity: 0
  },
  display: "inline-flex",
  alignItems: "center",
  gap: "spacing-100",
  cursor: "pointer",
  "&[data-disabled]": {
    opacity: 0.5,
    pointerEvents: "none"
  }
}), y = o({
  boxSize: "size-200",
  position: "absolute",
  top: "50%",
  display: "block",
  borderRadius: "full",
  transform: "translate(2px, -50%)",
  [a.variable]: i(r.primary[700], 0.2),
  [t.variable]: "shadows.100",
  boxShadow: [t.reference],
  backgroundColor: "white",
  transition: "left 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, transform 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
  '&[data-state="checked"]': {
    transform: "translate(22px, -50%)"
  },
  '&[data-state="unchecked"]': {}
}), g = o({
  display: "flex",
  gap: e(2),
  alignItems: "center",
  "& + p": {
    marginTop: 0
  }
}), f = c({
  control: p,
  label: m,
  labelTextContainer: b,
  root: u,
  thumb: y,
  tooltipIcon: g
}), w = d({
  baseStyle: f,
  variants: {
    default: {},
    full: {
      root: {
        width: "100%",
        justifyContent: "space-between"
      }
    }
  },
  defaultProps: {
    variant: "default"
  }
});
export {
  w as Toggle,
  g as tooltipIconStyles
};
//# sourceMappingURL=Toggle.es.js.map
